module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA4klEQVQ4T8XTIUtDURjG8d+arO4D2EXBtrqyZnZ1VdCubW0fQNkHsAg2BcsY6OLCcLC0NrDO4sCyIi8c4TLujtwVD5xwOM/zv/d9z/PW5NcXJmjvktUy/hFe8IEzdMu0OUALh1gidG9VAaG/xBzjfUoIzw2mGO4L6GGBh78AjxiU1BmAFe62ANGfC3SiOZ+4xWsSHaBR2EXvd9KH5xRXRcCsYKpvfTHysE57k+5OfgFxzpXwjqdcCbksRg/i/UszEMZckOL+fwHxVM00TPE3laP8jHsc4wjnVWehj2vEVO4c5x+B5y/r9jRF9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/around.png
// module id = Bpg0
// module chunks = 3